import {Component, Inject, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { Api } from '../../providers/api';
// import { FileDropModule, UploadFile, UploadEvent } from 'ngx-file-drop/lib/ngx-drop';
import {Subscription} from 'rxjs';
import { Http,RequestOptions ,Headers } from '@angular/http';

import { Observable } from 'rxjs/Observable';


// openDialogWithAResult
@Component({
    selector: 'license-failure-dialog',
    template: require('./license-failure-dialog.component.html')

})

export class LicenseFailureDialogComponent {

    busy: Subscription;
    uploading: Subscription;
     message: string="";



    constructor(public dialogRef: MatDialogRef<LicenseFailureDialogComponent>,private api:Api,@Inject(MAT_DIALOG_DATA) public data: any) {
        // this.dialogRef.disableClose = true;
        this.message =  data.message;
     }






    close(option: string) {
        if(option=='option-0') {
            let result = {message: "ReRoute to Manage License"};
            this.dialogRef.close(result);
        }else if('cross'){
            this.dialogRef.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/inventory/shipmentNotices/license-failure-dialog.component.ts